// ContactModal.js
import React from "react";
import ContactSection from "./ContactSectionpopup";
import "./ContactModal.css"; 

export default function ContactModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="contact-modal-overlay" onClick={onClose}>
      <div className="contact-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="contact-modal-close" onClick={onClose}>×</button>
        <ContactSection id="complaintnow" />
      </div>
    </div>
  );
}
